export default [
  {
    perantara: localStorage.kontrakPerantara,
    entitasPerantara: localStorage.kontrakEntitasPerantara,
    kodePenjualan: localStorage.kontrakKodePenjualan,
    komoditas: localStorage.kontrakKomoditas,
    harga: localStorage.kontrakHargaKomoditas,
    color: 'light-blue',
    icon: 'fas fa-file-alt',
    timeLabel: 'Just now'
  },
  // { divider: true, inset: true },
  // {
  //   brokeredBy: localStorage.kontrakBrokeredBy,
  //   kode: localStorage.kodePenjualan,
  //   color: 'light-blue',
  //   icon: 'fas fa-file-alt',
  //   timeLabel: '2 min ago'
  // },
  // { divider: true, inset: true },
  // {
  //   brokeredBy: localStorage.kontrakBrokeredBy,
  //   kode: localStorage.kodePenjualan,
  //   color: 'light-blue',
  //   icon: 'fas fa-file-alt',
  //   timeLabel: '24 min ago'
  // },
  // { divider: true, inset: true },
  // {
  //   brokeredBy: localStorage.kontrakBrokeredBy,
  //   kode: localStorage.kodePenjualan,
  //   color: 'light-blue',
  //   icon: 'fas fa-file-alt',
  //   timeLabel: '1 hour ago'
  // }
];
